import React from 'react';
import { BookOpen, Lock, ArrowRight } from 'lucide-react';

const ChaptersPage = () => {
  const chapters = [
    { number: 1, title: "The Manuscript", available: true },
    { number: 2, title: "Hidden in Plain Sight", available: true },
    { number: 3, title: "The Cipher", available: false },
    { number: 4, title: "Prague Shadows", available: false },
    { number: 5, title: "The Vatican Connection", available: false },
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Chapters</h1>
          <p className="text-xl opacity-90">Read the first two chapters for free</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">Free Preview</h2>
            <div className="grid grid-cols-1 gap-6">
              {chapters.map((chapter) => (
                <div key={chapter.number} className="bg-white rounded-xl shadow-md p-6 flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                      {chapter.available ? (
                        <BookOpen className="w-6 h-6 text-amber-600" />
                      ) : (
                        <Lock className="w-6 h-6 text-gray-400" />
                      )}
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">Chapter {chapter.number}: {chapter.title}</h3>
                      <p className="text-gray-600 text-sm">
                        {chapter.available ? 'Available now' : 'Available in full book'}
                      </p>
                    </div>
                  </div>
                  {chapter.available ? (
                    <button className="text-amber-600 font-semibold hover:text-amber-800 flex items-center">
                      Read <ArrowRight className="ml-2" size={18} />
                    </button>
                  ) : (
                    <button className="bg-gray-200 text-gray-500 px-4 py-2 rounded-full font-semibold cursor-not-allowed">
                      Locked
                    </button>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <p className="text-lg text-gray-600 mb-6">
                Want to read the rest of the book? Get your copy today!
              </p>
              <a href="/buy" className="bg-amber-500 text-gray-900 px-8 py-4 rounded-full font-semibold hover:bg-amber-400 transition inline-block">
                Buy Now - $14.99
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChaptersPage;